var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.166626V6.49996H6.83333C3.35 6.49996 0.5 9.34996 0.5 12.8333V57.1666C0.5 60.65 3.35 63.5 6.83333 63.5H51.1667C54.65 63.5 57.5 60.65 57.5 57.1666V12.8333C57.5 9.34996 54.65 6.49996 51.1667 6.49996H48V0.166626H41.6667V6.49996H16.3333V0.166626H10ZM6.83333 12.8333H10H16.3333H41.6667H48H51.1667V19.1666H6.83333V12.8333ZM6.83333 25.5H51.1667V57.1666H6.83333V25.5Z",
    fill: "#3C3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e6c6bcb79662315ba5728c0fab3b89d6.svg";
export { ForwardRef as ReactComponent };